<template lang='pug'>
  //- 已存在提示區塊
  div(:class='$style[`cc-popbox-help-filter`]')
    div(:class='$style[`cc-content-new`]')
      div(:class='$style[`cc-help-filter-wrap`]')
        div(:class='[$style[`cc-help-filter-list`], $style[`cc-help-filter-list-inputer`]]')
          h2.font-medium!= '選擇癌症別'
          div(:class='$style[`cc-help-filter-list-nav`]')
            Select(
              title='選擇癌症別'
              :class='$style[`cc-content-new-select`]'
              :placeholder='`請選擇`'
              :defaultValue='query.tag'
              :beforeIcon='`tag`'
              :beforeIconSize='24'
              :beforeIconColor='`#d0d0d0`'
              :optionList='CANCER_TYPE_FIX'
              @sendSelectValue='watchTagUpdate')

        div(:class='[$style[`cc-help-filter-list`], $style[`cc-help-filter-list-inputer`]]')
          h2.font-medium!= '選擇地區'
          div(:class='$style[`cc-help-filter-list-nav`]')
            Select(
              title='選擇地區'
              :class='$style[`cc-content-new-select`]'
              :placeholder='`請選擇`'
              :defaultValue='query.location'
              :beforeIcon='`location`'
              :beforeIconSize='24'
              :beforeIconColor='`#d0d0d0`'
              :optionList='[`所有地區`, `台北市`, `新北市`, `桃園市`, `臺中市`, `臺南市`, `高雄市`, `基隆市`, `新竹市`, `嘉義市`, `宜蘭縣`, `新竹縣`, `苗栗縣`, `彰化縣`, `南投縣`, `雲林縣`, `嘉義縣`, `屏東縣`, `花蓮縣`, `臺東縣`, `澎湖縣`]'
              @sendSelectValue='watchLocationUpdate')

        div(:class='[$style[`cc-help-filter-list`], $style[`cc-help-filter-list-selector`]]')
          h2.font-medium!= '選擇服務類型'
            span(:class='$style[`cc-help-filter-list-tip`]')!= '至少1項'
          ul(:class='$style[`cc-help-filter-list-ul`]')
            li(:class='$style[`cc-help-filter-list-li`]')
              CheckBox2(
                :labelText='`諮詢服務`'
                :defaultChecked='checkFeatureInclude(`諮詢服務`)'
                @sendCheckStatus='watchCheckBoxUpdate')
            li(:class='$style[`cc-help-filter-list-li`]')
              CheckBox2(
                :labelText='`營養指南`'
                :defaultChecked='checkFeatureInclude(`營養指南`)'
                @sendCheckStatus='watchCheckBoxUpdate')
            li(:class='$style[`cc-help-filter-list-li`]')
              CheckBox2(
                :labelText='`講座活動`'
                :defaultChecked='checkFeatureInclude(`講座活動`)'
                @sendCheckStatus='watchCheckBoxUpdate')
            li(:class='$style[`cc-help-filter-list-li`]')
              CheckBox2(
                :labelText='`資源補助`'
                :defaultChecked='checkFeatureInclude(`資源補助`)'
                @sendCheckStatus='watchCheckBoxUpdate')
            li(:class='$style[`cc-help-filter-list-li`]')
              CheckBox2(
                :labelText='`器材租借`'
                :defaultChecked='checkFeatureInclude(`器材租借`)'
                @sendCheckStatus='watchCheckBoxUpdate')
            li(:class='$style[`cc-help-filter-list-li`]')
              CheckBox2(
                :labelText='`加入志工`'
                :defaultChecked='checkFeatureInclude(`加入志工`)'
                @sendCheckStatus='watchCheckBoxUpdate')

      div(:class='$style[`cc-content-btn-area`]')
        div(
          title='查詢'
          :class='[$style[`cc-content-btn`], $style[`cc-content-btn-send`]]'
          @click='handleClickToClose')
          span {{ `查詢`}}
        div(
          title='取消'
          :class='[$style[`cc-content-btn`], $style[`cc-content-btn-close`]]'
          @click='handleClickToClose')
          span 取消


</template>

<script>
import { mapMutations } from 'vuex';
import CheckBox2 from '../common/Checkbox2.vue';
import Select from '../common/Select.vue';

export default {
  components: {
    CheckBox2,
    Select,
  },

  props: {
    query: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      featureChoose: [],
      selectFilter: this.query,
    };
  },

  created() {
    this.featureChoose = this.query.feature.split(',');
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopHelpFilterStatus: 'global/POPHELP_FILTER_STATUS',
    }),

    checkFeatureInclude(feature) {
      return this.featureChoose.includes(feature);
    },

    watchLocationUpdate(value) {
      if (this.selectFilter.location === value) { return; }
      if (value === '所有地區' && this.selectFilter.location === '') { return; }

      const flowProcess = new Promise((resolve) => {
        // eslint-disable-next-line no-unused-expressions
        value === '所有地區' ? this.selectFilter.location = '' : this.selectFilter.location = value;
        return resolve();
      });

      flowProcess.then(() => {
        this.routeQueryPushProcess();
      });
    },

    watchTagUpdate(value) {
      if (this.selectFilter.tag === value) { return; }
      if (value === '所有癌症' && this.selectFilter.tag === '') { return; }

      const flowProcess = new Promise((resolve) => {
        // eslint-disable-next-line no-unused-expressions
        value === '所有癌症' ? this.selectFilter.tag = '' : this.selectFilter.tag = value;
        return resolve();
      });

      flowProcess.then(() => {
        this.routeQueryPushProcess();
      });
    },

    watchCheckBoxUpdate(value, text) {
      if (value === 'checked') {
        this.featureChoose.push(text);
      } else {
        const filterArray = this.featureChoose.filter((e) => e !== text);
        this.featureChoose = filterArray;
      }

      this.selectFilter.feature = JSON.stringify(this.featureChoose).replace(/\[|]/g, '').replace(/["']/g, '');

      // eslint-disable-next-line no-console
      this.routeQueryPushProcess();
    },

    routeQueryPushProcess() {
      this.$router.push({
        name: 'help',
        query: {
          f: !this.selectFilter.feature ? '' : this.selectFilter.feature,
          l: !this.selectFilter.location ? '' : this.selectFilter.location,
          t: !this.selectFilter.tag ? '' : this.selectFilter.tag,
        },
      }).catch(() => true);
    },

    handleClickToClose() {
      this.changePopHelpFilterStatus({
        active: false,
        query: null,
      });
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popHelpFilter.scss';
</style>
